import Swiper from 'swiper'
import { A11y, Navigation } from 'swiper/modules'
import { on } from 'delegated-events'
import pageFilters from '@components/page-filters'

const setupSlider = (el) => {
  if (el.classList.contains('did-init')) {
    return
  }

  const container = el.querySelector('.swiper')
  const viewAllToggles = el.querySelectorAll('.view-all-toggle')
  const topViewAllToggle = el.querySelector('.top-view-all-toggle')
  const sliderControls = el.querySelector('.slider-controls')

  const swiper = new Swiper(container, {
    modules: [A11y, Navigation],
    slidesPerView: 1,
    navigation: {
      nextEl: el.querySelector('.slider-button-next'),
      prevEl: el.querySelector('.slider-button-prev'),
    },
    watchSlidesProgress: true,
    breakpoints: {
      768: {
        slidesPerView: 3,
      },
      1280: {
        slidesPerView: 4,
      },
    },
    on: {
      afterInit: (swiper) => {
        if (topViewAllToggle) {
          if (swiper.isLocked) {
            topViewAllToggle.classList.add('invisible')
          } else {
            topViewAllToggle.classList.remove('invisible')
          }
        }

        if (sliderControls) {
          sliderControls.classList.remove('invisible')
        }
      },
      resize: (swiper) => {
        if (topViewAllToggle) {
          if (swiper.isLocked) {
            topViewAllToggle.classList.add('invisible')
          } else {
            topViewAllToggle.classList.remove('invisible')
          }
        }
      },
    },
  })

  if (viewAllToggles.length) {
    viewAllToggles.forEach((button) => {
      button.addEventListener('click', () => {
        el.classList.toggle('is-view-all')

        if (el.classList.contains('is-view-all')) {
          swiper.slideTo(0, 0)
          swiper.disable()
        } else {
          swiper.enable()
        }
      })
    })
  }

  el.classList.add('did-init')
}

export default {
  init: () => {
    pageFilters.init()

    on('pagecontent:replace', 'html', () => {
      document.querySelectorAll('.portal-slider.is-active').forEach((slider) => {
        setupSlider(slider)
      })
    })

    on('slidetoggle:open', 'html', (e) => {
      const categorySlider = e.detail.target.parentNode.querySelector('.category-slider')
      const subCategorySlider = e.detail.target.closest('.portal-slider')

      if (categorySlider) {
        setupSlider(categorySlider)
      }

      if (subCategorySlider) {
        setupSlider(subCategorySlider)
      }
    })
  },
}
